<app-report-info-item
  [data]="{ label: 'reportInfo.lastUpdatedBy', values: [data().lastUpdatedBy] }"
/>
<hr />
<app-report-info-item
  [data]="{
    label: data().referenceField.label,
    values: data().referenceField.values,
  }"
/>
<hr />
<div class="status-wrapper">
  <app-report-info-item
    [data]="{
      label: 'reportInfo.status',
      values: ['reportStatus.' + data().status],
    }"
  />
  <div class="icon-wrapper">
    @if (data().showDeviationPill && data().isDeviation) {
      <gc-pill [color]="'critical'">{{
        'reportInfo.deviation' | translate
      }}</gc-pill>
    }
    @if (isReportTypeSpan) {
      <img
        class="status-icon"
        [src]="statusIconLink"
        [alt]="'reportInfo.reportStatusIcon' | translate"
        onerror="this.style.display = 'none'"
      />
    }
  </div>
</div>
@for (group of data().groups; track $index) {
  <hr />
  @for (item of group; track $index) {
    <app-report-info-item [data]="item" />
  }
}
